// Inbound email intake addressing. Email routing matches the `+<tag>` against
// the raw stored public code (uppercase, no separators), so the address must
// use the unformatted code — not the dashed display form.
export const INBOUND_EMAIL_DOMAIN = "inbound.os04.app";

export function intakeAddress(publicCode?: string | null): string | null {
  const normalized = (publicCode ?? "")
    .trim()
    .toUpperCase()
    .replace(/[^A-Z0-9]/g, "");
  if (!normalized) {
    return null;
  }
  return `intake+${normalized}@${INBOUND_EMAIL_DOMAIN}`;
}
